module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'ybhlhhup',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
